import { zodResolver } from "@hookform/resolvers/zod";
import { Button, InputField } from "components";
import { Empty } from "components/atoms/Empty";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { handleToggleExport } from "store/slices/ui.slice";
import constants from "utils/constants";
import { useTable } from "utils/hooks/useTable";
import { schema } from "./schema";
import { exportContactRevealedByIDs } from "store/slices/data.slice";
import { useCallback, useId, useState } from "react";
import { EnrichmentContactRevealSourceENUM } from "utils/enums/enrichmentENUM";
import { z } from "zod";
import { toastHelper } from "utils/helper";

export const ExportSelected = () => {
  const [exporting, setExporting] = useState(false);
  const { count } = useAppSelector((state) => state.insights.leads);
  const {
    isAllSelected,
    selectedRows,
    unselectedIds,
    totalItemsSelecteds,
    handleDeselectAll,
  } = useTable({ totalItems: count });
  const toastId = useId();
  const dispatch = useAppDispatch();
  const form = useForm({ resolver: zodResolver(schema) });
  const itemsSleected =
    totalItemsSelecteds > 0
      ? Number(
          count > constants.LIMIT_ENRICHMENT_ATTEMPT_PER_TASK
            ? constants.LIMIT_ENRICHMENT_ATTEMPT_PER_TASK
            : totalItemsSelecteds
        )
      : totalItemsSelecteds;
  const handleExport = useCallback(
    async (value: z.infer<typeof schema>) => {
      setExporting(true);
      toastHelper({
        toastId,
        message: "Please wait, Exporting leads",
        type: "info",
      });

      try {
        const payload = {
          query: "",
          source: EnrichmentContactRevealSourceENUM.PIXEL,
          isAllLeadsSelected: isAllSelected,
          listName: value.name,
          leadHistoryCount: totalItemsSelecteds,
          leadIds: isAllSelected ? [] : selectedRows,
          leadIdsToIgnore: isAllSelected ? unselectedIds : [],
        };

        await dispatch(exportContactRevealedByIDs(payload));

        toastHelper({
          toastId,
          message:
            "Your list is being processed. It should be ready in about a minute",
          type: "success",
        });

        handleDeselectAll();
        dispatch(handleToggleExport());
      } catch (erro) {
        toastHelper({
          toastId,
          message: "Error exporting leads",
          type: "error",
        });
      } finally {
        setExporting(false);
      }
    },
    [isAllSelected, selectedRows, unselectedIds, totalItemsSelecteds, toastId]
  );

  return (
    <div
      className={`row-start-1 w-full max-w-[400px] border-l border-gray-700 justify-center row-span-12  items-center overflow-hidden flex flex-col h-full border-r p-4 text-center col-start-10 col-span-3`}
    >
      <div className="flex flex-col h-fit justify-center gap-4">
        <Empty
          title="Export as CSV"
          message={
            <>
              <p className="text-gray-400 text-base mb-2 mt-4">
                Please note that by adding new contacts to a list costs 1
                enrichment credit per lead.
                <br /> Adding previously saved contacts to a list does not cost
                credits.
              </p>
              <b> {itemsSleected} leads selected </b>
            </>
          }
        />
        <FormProvider {...form}>
          <form
            className="flex flex-col max-w-md justify-center gap-6 items-center w-full mt-6"
            onSubmit={form.handleSubmit(handleExport)}
          >
            <Controller
              name="name"
              render={({ field: { onChange, value } }) => (
                <InputField
                  value={value}
                  placeholder="Add a name to your list"
                  size="small"
                  onChange={onChange}
                />
              )}
            />
            <Button
              disabled={!form.formState.isValid || exporting}
              isProcessing={exporting}
              iconName="download"
              size="sm"
            >
              {" "}
              Save Contacts{" "}
            </Button>
            <Button
              type="download"
              action="button"
              onClick={() => dispatch(handleToggleExport())}
              iconName="close"
              size="sm"
            >
              {" "}
              cancel{" "}
            </Button>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};
